module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-10-01",
		"endpointPrefix": "gamelift",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "Amazon GameLift",
		"signatureVersion": "v4",
		"targetPrefix": "GameLift",
		"uid": "gamelift-2015-10-01"
	},
	"operations": {
		"CreateAlias": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"RoutingStrategy"
				],
				"members": {
					"Name": {},
					"Description": {},
					"RoutingStrategy": {
						"shape": "S4"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Alias": {
						"shape": "S9"
					}
				}
			}
		},
		"CreateBuild": {
			"input": {
				"type": "structure",
				"members": {
					"Name": {},
					"Version": {},
					"StorageLocation": {
						"shape": "Se"
					},
					"OperatingSystem": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Build": {
						"shape": "Si"
					},
					"UploadCredentials": {
						"shape": "Sm"
					},
					"StorageLocation": {
						"shape": "Se"
					}
				}
			}
		},
		"CreateFleet": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"BuildId",
					"EC2InstanceType"
				],
				"members": {
					"Name": {},
					"Description": {},
					"BuildId": {},
					"ServerLaunchPath": {},
					"ServerLaunchParameters": {},
					"LogPaths": {
						"shape": "So"
					},
					"EC2InstanceType": {},
					"EC2InboundPermissions": {
						"shape": "Sq"
					},
					"NewGameSessionProtectionPolicy": {},
					"RuntimeConfiguration": {
						"shape": "Sw"
					},
					"ResourceCreationLimitPolicy": {
						"shape": "S10"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetAttributes": {
						"shape": "S13"
					}
				}
			}
		},
		"CreateGameSession": {
			"input": {
				"type": "structure",
				"required": [
					"MaximumPlayerSessionCount"
				],
				"members": {
					"FleetId": {},
					"AliasId": {},
					"MaximumPlayerSessionCount": {
						"type": "integer"
					},
					"Name": {},
					"GameProperties": {
						"shape": "S16"
					},
					"CreatorId": {},
					"GameSessionId": {},
					"IdempotencyToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSession": {
						"shape": "S1c"
					}
				}
			}
		},
		"CreateGameSessionQueue": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"TimeoutInSeconds": {
						"type": "integer"
					},
					"PlayerLatencyPolicies": {
						"shape": "S1i"
					},
					"Destinations": {
						"shape": "S1k"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessionQueue": {
						"shape": "S1n"
					}
				}
			}
		},
		"CreatePlayerSession": {
			"input": {
				"type": "structure",
				"required": [
					"GameSessionId",
					"PlayerId"
				],
				"members": {
					"GameSessionId": {},
					"PlayerId": {},
					"PlayerData": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PlayerSession": {
						"shape": "S1r"
					}
				}
			}
		},
		"CreatePlayerSessions": {
			"input": {
				"type": "structure",
				"required": [
					"GameSessionId",
					"PlayerIds"
				],
				"members": {
					"GameSessionId": {},
					"PlayerIds": {
						"type": "list",
						"member": {}
					},
					"PlayerDataMap": {
						"type": "map",
						"key": {},
						"value": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PlayerSessions": {
						"shape": "S1y"
					}
				}
			}
		},
		"DeleteAlias": {
			"input": {
				"type": "structure",
				"required": [
					"AliasId"
				],
				"members": {
					"AliasId": {}
				}
			}
		},
		"DeleteBuild": {
			"input": {
				"type": "structure",
				"required": [
					"BuildId"
				],
				"members": {
					"BuildId": {}
				}
			}
		},
		"DeleteFleet": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {}
				}
			}
		},
		"DeleteGameSessionQueue": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteScalingPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"FleetId"
				],
				"members": {
					"Name": {},
					"FleetId": {}
				}
			}
		},
		"DescribeAlias": {
			"input": {
				"type": "structure",
				"required": [
					"AliasId"
				],
				"members": {
					"AliasId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Alias": {
						"shape": "S9"
					}
				}
			}
		},
		"DescribeBuild": {
			"input": {
				"type": "structure",
				"required": [
					"BuildId"
				],
				"members": {
					"BuildId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Build": {
						"shape": "Si"
					}
				}
			}
		},
		"DescribeEC2InstanceLimits": {
			"input": {
				"type": "structure",
				"members": {
					"EC2InstanceType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"EC2InstanceLimits": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"EC2InstanceType": {},
								"CurrentInstances": {
									"type": "integer"
								},
								"InstanceLimit": {
									"type": "integer"
								}
							}
						}
					}
				}
			}
		},
		"DescribeFleetAttributes": {
			"input": {
				"type": "structure",
				"members": {
					"FleetIds": {
						"shape": "S2e"
					},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetAttributes": {
						"type": "list",
						"member": {
							"shape": "S13"
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeFleetCapacity": {
			"input": {
				"type": "structure",
				"members": {
					"FleetIds": {
						"shape": "S2e"
					},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetCapacity": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"FleetId": {},
								"InstanceType": {},
								"InstanceCounts": {
									"type": "structure",
									"members": {
										"DESIRED": {
											"type": "integer"
										},
										"MINIMUM": {
											"type": "integer"
										},
										"MAXIMUM": {
											"type": "integer"
										},
										"PENDING": {
											"type": "integer"
										},
										"ACTIVE": {
											"type": "integer"
										},
										"IDLE": {
											"type": "integer"
										},
										"TERMINATING": {
											"type": "integer"
										}
									}
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeFleetEvents": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Events": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"EventId": {},
								"ResourceId": {},
								"EventCode": {},
								"Message": {},
								"EventTime": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeFleetPortSettings": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InboundPermissions": {
						"shape": "Sq"
					}
				}
			}
		},
		"DescribeFleetUtilization": {
			"input": {
				"type": "structure",
				"members": {
					"FleetIds": {
						"shape": "S2e"
					},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetUtilization": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"FleetId": {},
								"ActiveServerProcessCount": {
									"type": "integer"
								},
								"ActiveGameSessionCount": {
									"type": "integer"
								},
								"CurrentPlayerSessionCount": {
									"type": "integer"
								},
								"MaximumPlayerSessionCount": {
									"type": "integer"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeGameSessionDetails": {
			"input": {
				"type": "structure",
				"members": {
					"FleetId": {},
					"GameSessionId": {},
					"AliasId": {},
					"StatusFilter": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessionDetails": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"GameSession": {
									"shape": "S1c"
								},
								"ProtectionPolicy": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeGameSessionPlacement": {
			"input": {
				"type": "structure",
				"required": [
					"PlacementId"
				],
				"members": {
					"PlacementId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessionPlacement": {
						"shape": "S33"
					}
				}
			}
		},
		"DescribeGameSessionQueues": {
			"input": {
				"type": "structure",
				"members": {
					"Names": {
						"type": "list",
						"member": {}
					},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessionQueues": {
						"type": "list",
						"member": {
							"shape": "S1n"
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeGameSessions": {
			"input": {
				"type": "structure",
				"members": {
					"FleetId": {},
					"GameSessionId": {},
					"AliasId": {},
					"StatusFilter": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessions": {
						"shape": "S3g"
					},
					"NextToken": {}
				}
			}
		},
		"DescribeInstances": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {},
					"InstanceId": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Instances": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"FleetId": {},
								"InstanceId": {},
								"IpAddress": {},
								"OperatingSystem": {},
								"Type": {},
								"Status": {},
								"CreationTime": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribePlayerSessions": {
			"input": {
				"type": "structure",
				"members": {
					"GameSessionId": {},
					"PlayerId": {},
					"PlayerSessionId": {},
					"PlayerSessionStatusFilter": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PlayerSessions": {
						"shape": "S1y"
					},
					"NextToken": {}
				}
			}
		},
		"DescribeRuntimeConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RuntimeConfiguration": {
						"shape": "Sw"
					}
				}
			}
		},
		"DescribeScalingPolicies": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {},
					"StatusFilter": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ScalingPolicies": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"FleetId": {},
								"Name": {},
								"Status": {},
								"ScalingAdjustment": {
									"type": "integer"
								},
								"ScalingAdjustmentType": {},
								"ComparisonOperator": {},
								"Threshold": {
									"type": "double"
								},
								"EvaluationPeriods": {
									"type": "integer"
								},
								"MetricName": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"GetGameSessionLogUrl": {
			"input": {
				"type": "structure",
				"required": [
					"GameSessionId"
				],
				"members": {
					"GameSessionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PreSignedUrl": {}
				}
			}
		},
		"GetInstanceAccess": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId",
					"InstanceId"
				],
				"members": {
					"FleetId": {},
					"InstanceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceAccess": {
						"type": "structure",
						"members": {
							"FleetId": {},
							"InstanceId": {},
							"IpAddress": {},
							"OperatingSystem": {},
							"Credentials": {
								"type": "structure",
								"members": {
									"UserName": {},
									"Secret": {}
								},
								"sensitive": true
							}
						}
					}
				}
			}
		},
		"ListAliases": {
			"input": {
				"type": "structure",
				"members": {
					"RoutingStrategyType": {},
					"Name": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Aliases": {
						"type": "list",
						"member": {
							"shape": "S9"
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListBuilds": {
			"input": {
				"type": "structure",
				"members": {
					"Status": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Builds": {
						"type": "list",
						"member": {
							"shape": "Si"
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListFleets": {
			"input": {
				"type": "structure",
				"members": {
					"BuildId": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetIds": {
						"shape": "S2e"
					},
					"NextToken": {}
				}
			}
		},
		"PutScalingPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"FleetId",
					"ScalingAdjustment",
					"ScalingAdjustmentType",
					"Threshold",
					"ComparisonOperator",
					"EvaluationPeriods",
					"MetricName"
				],
				"members": {
					"Name": {},
					"FleetId": {},
					"ScalingAdjustment": {
						"type": "integer"
					},
					"ScalingAdjustmentType": {},
					"Threshold": {
						"type": "double"
					},
					"ComparisonOperator": {},
					"EvaluationPeriods": {
						"type": "integer"
					},
					"MetricName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Name": {}
				}
			}
		},
		"RequestUploadCredentials": {
			"input": {
				"type": "structure",
				"required": [
					"BuildId"
				],
				"members": {
					"BuildId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UploadCredentials": {
						"shape": "Sm"
					},
					"StorageLocation": {
						"shape": "Se"
					}
				}
			}
		},
		"ResolveAlias": {
			"input": {
				"type": "structure",
				"required": [
					"AliasId"
				],
				"members": {
					"AliasId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetId": {}
				}
			}
		},
		"SearchGameSessions": {
			"input": {
				"type": "structure",
				"members": {
					"FleetId": {},
					"AliasId": {},
					"FilterExpression": {},
					"SortExpression": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessions": {
						"shape": "S3g"
					},
					"NextToken": {}
				}
			}
		},
		"StartGameSessionPlacement": {
			"input": {
				"type": "structure",
				"required": [
					"PlacementId",
					"GameSessionQueueName",
					"MaximumPlayerSessionCount"
				],
				"members": {
					"PlacementId": {},
					"GameSessionQueueName": {},
					"GameProperties": {
						"shape": "S16"
					},
					"MaximumPlayerSessionCount": {
						"type": "integer"
					},
					"GameSessionName": {},
					"PlayerLatencies": {
						"shape": "S35"
					},
					"DesiredPlayerSessions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"PlayerId": {},
								"PlayerData": {}
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessionPlacement": {
						"shape": "S33"
					}
				}
			}
		},
		"StopGameSessionPlacement": {
			"input": {
				"type": "structure",
				"required": [
					"PlacementId"
				],
				"members": {
					"PlacementId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessionPlacement": {
						"shape": "S33"
					}
				}
			}
		},
		"UpdateAlias": {
			"input": {
				"type": "structure",
				"required": [
					"AliasId"
				],
				"members": {
					"AliasId": {},
					"Name": {},
					"Description": {},
					"RoutingStrategy": {
						"shape": "S4"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Alias": {
						"shape": "S9"
					}
				}
			}
		},
		"UpdateBuild": {
			"input": {
				"type": "structure",
				"required": [
					"BuildId"
				],
				"members": {
					"BuildId": {},
					"Name": {},
					"Version": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Build": {
						"shape": "Si"
					}
				}
			}
		},
		"UpdateFleetAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {},
					"Name": {},
					"Description": {},
					"NewGameSessionProtectionPolicy": {},
					"ResourceCreationLimitPolicy": {
						"shape": "S10"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetId": {}
				}
			}
		},
		"UpdateFleetCapacity": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {},
					"DesiredInstances": {
						"type": "integer"
					},
					"MinSize": {
						"type": "integer"
					},
					"MaxSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetId": {}
				}
			}
		},
		"UpdateFleetPortSettings": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {},
					"InboundPermissionAuthorizations": {
						"shape": "Sq"
					},
					"InboundPermissionRevocations": {
						"shape": "Sq"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetId": {}
				}
			}
		},
		"UpdateGameSession": {
			"input": {
				"type": "structure",
				"required": [
					"GameSessionId"
				],
				"members": {
					"GameSessionId": {},
					"MaximumPlayerSessionCount": {
						"type": "integer"
					},
					"Name": {},
					"PlayerSessionCreationPolicy": {},
					"ProtectionPolicy": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSession": {
						"shape": "S1c"
					}
				}
			}
		},
		"UpdateGameSessionQueue": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"TimeoutInSeconds": {
						"type": "integer"
					},
					"PlayerLatencyPolicies": {
						"shape": "S1i"
					},
					"Destinations": {
						"shape": "S1k"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessionQueue": {
						"shape": "S1n"
					}
				}
			}
		},
		"UpdateRuntimeConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId",
					"RuntimeConfiguration"
				],
				"members": {
					"FleetId": {},
					"RuntimeConfiguration": {
						"shape": "Sw"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RuntimeConfiguration": {
						"shape": "Sw"
					}
				}
			}
		}
	},
	"shapes": {
		"S4": {
			"type": "structure",
			"members": {
				"Type": {},
				"FleetId": {},
				"Message": {}
			}
		},
		"S9": {
			"type": "structure",
			"members": {
				"AliasId": {},
				"Name": {},
				"AliasArn": {},
				"Description": {},
				"RoutingStrategy": {
					"shape": "S4"
				},
				"CreationTime": {
					"type": "timestamp"
				},
				"LastUpdatedTime": {
					"type": "timestamp"
				}
			}
		},
		"Se": {
			"type": "structure",
			"members": {
				"Bucket": {},
				"Key": {},
				"RoleArn": {}
			}
		},
		"Si": {
			"type": "structure",
			"members": {
				"BuildId": {},
				"Name": {},
				"Version": {},
				"Status": {},
				"SizeOnDisk": {
					"type": "long"
				},
				"OperatingSystem": {},
				"CreationTime": {
					"type": "timestamp"
				}
			}
		},
		"Sm": {
			"type": "structure",
			"members": {
				"AccessKeyId": {},
				"SecretAccessKey": {},
				"SessionToken": {}
			},
			"sensitive": true
		},
		"So": {
			"type": "list",
			"member": {}
		},
		"Sq": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"FromPort",
					"ToPort",
					"IpRange",
					"Protocol"
				],
				"members": {
					"FromPort": {
						"type": "integer"
					},
					"ToPort": {
						"type": "integer"
					},
					"IpRange": {},
					"Protocol": {}
				}
			}
		},
		"Sw": {
			"type": "structure",
			"members": {
				"ServerProcesses": {
					"type": "list",
					"member": {
						"type": "structure",
						"required": [
							"LaunchPath",
							"ConcurrentExecutions"
						],
						"members": {
							"LaunchPath": {},
							"Parameters": {},
							"ConcurrentExecutions": {
								"type": "integer"
							}
						}
					}
				}
			}
		},
		"S10": {
			"type": "structure",
			"members": {
				"NewGameSessionsPerCreator": {
					"type": "integer"
				},
				"PolicyPeriodInMinutes": {
					"type": "integer"
				}
			}
		},
		"S13": {
			"type": "structure",
			"members": {
				"FleetId": {},
				"FleetArn": {},
				"Description": {},
				"Name": {},
				"CreationTime": {
					"type": "timestamp"
				},
				"TerminationTime": {
					"type": "timestamp"
				},
				"Status": {},
				"BuildId": {},
				"ServerLaunchPath": {},
				"ServerLaunchParameters": {},
				"LogPaths": {
					"shape": "So"
				},
				"NewGameSessionProtectionPolicy": {},
				"OperatingSystem": {},
				"ResourceCreationLimitPolicy": {
					"shape": "S10"
				}
			}
		},
		"S16": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Key",
					"Value"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"S1c": {
			"type": "structure",
			"members": {
				"GameSessionId": {},
				"Name": {},
				"FleetId": {},
				"CreationTime": {
					"type": "timestamp"
				},
				"TerminationTime": {
					"type": "timestamp"
				},
				"CurrentPlayerSessionCount": {
					"type": "integer"
				},
				"MaximumPlayerSessionCount": {
					"type": "integer"
				},
				"Status": {},
				"GameProperties": {
					"shape": "S16"
				},
				"IpAddress": {},
				"Port": {
					"type": "integer"
				},
				"PlayerSessionCreationPolicy": {},
				"CreatorId": {}
			}
		},
		"S1i": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"MaximumIndividualPlayerLatencyMilliseconds": {
						"type": "integer"
					},
					"PolicyDurationSeconds": {
						"type": "integer"
					}
				}
			}
		},
		"S1k": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"DestinationArn": {}
				}
			}
		},
		"S1n": {
			"type": "structure",
			"members": {
				"Name": {},
				"GameSessionQueueArn": {},
				"TimeoutInSeconds": {
					"type": "integer"
				},
				"PlayerLatencyPolicies": {
					"shape": "S1i"
				},
				"Destinations": {
					"shape": "S1k"
				}
			}
		},
		"S1r": {
			"type": "structure",
			"members": {
				"PlayerSessionId": {},
				"PlayerId": {},
				"GameSessionId": {},
				"FleetId": {},
				"CreationTime": {
					"type": "timestamp"
				},
				"TerminationTime": {
					"type": "timestamp"
				},
				"Status": {},
				"IpAddress": {},
				"Port": {
					"type": "integer"
				},
				"PlayerData": {}
			}
		},
		"S1y": {
			"type": "list",
			"member": {
				"shape": "S1r"
			}
		},
		"S2e": {
			"type": "list",
			"member": {}
		},
		"S33": {
			"type": "structure",
			"members": {
				"PlacementId": {},
				"GameSessionQueueName": {},
				"Status": {},
				"GameProperties": {
					"shape": "S16"
				},
				"MaximumPlayerSessionCount": {
					"type": "integer"
				},
				"GameSessionName": {},
				"GameSessionId": {},
				"GameSessionArn": {},
				"GameSessionRegion": {},
				"PlayerLatencies": {
					"shape": "S35"
				},
				"StartTime": {
					"type": "timestamp"
				},
				"EndTime": {
					"type": "timestamp"
				},
				"IpAddress": {},
				"Port": {
					"type": "integer"
				},
				"PlacedPlayerSessions": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"PlayerId": {},
							"PlayerSessionId": {}
						}
					}
				}
			}
		},
		"S35": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"PlayerId": {},
					"RegionIdentifier": {},
					"LatencyInMilliseconds": {
						"type": "float"
					}
				}
			}
		},
		"S3g": {
			"type": "list",
			"member": {
				"shape": "S1c"
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/gamelift-2015-10-01.min.json
// module id = 657
// module chunks = 0